var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 35,
    viewBox: "0 0 34 35"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.426,
    height: 6.316,
    x: -4.215,
    y: 13.844,
    rx: 0.75,
    transform: "rotate(45 16.998 17.002)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.235.3-13.94 13.939a.75.75 0 0 0 0 1.06l3.406 3.406a.75.75 0 0 0 1.06 0l13.94-13.94a.75.75 0 0 0 0-1.06L30.295.299a.75.75 0 0 0-1.06 0zM3.738 34.766l10.73-10.73a.59.59 0 0 0 0-.855l-3.606-3.606a.59.59 0 0 0-.856 0l3.396-3.395-7.582 7.582-3.425 3.424a1.43 1.43 0 0 0-.428 1.04l-.001 5.012c0 .367.183.795.427 1.04l.49.488"
  })));
};
export default SvgClose;